import { atom } from 'jotai';

export const notificationUnreadCountAtom = atom(0);
